import React, { useState, useEffect} from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from './apiConfig';
import { getStatusMessage } from './statusMessages';
import { useAuth } from "./AuthContext";
import occupationList from './occupations.json';
import { containsForbiddenContactInfo,cleanForbiddenContactInfo } from './containsForbiddenContactInfo';


function UpdateDetailsForm() {


  const { token } = useAuth();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [initialFormData, setInitialFormData] = useState(null);
  

  const [tokenVal, settokenVal] = useState('')

    useEffect(() => {
        settokenVal(token)
      }, []);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    age: '',
    genderID: '',
    mstatusID: '',
    heightFt: '',
    heightIn: '',
    occupationID: '',
    occupation: '',
    about: '',
  });

  const [errors, setErrors] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [animateArrow, setAnimateArrow] = useState(false);


  useEffect(() => {
  if (!token) return;

  const fetchDetails = async () => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.GETDETAILS,
        {},
        {
          headers: {
            token: token,
          },
        }
      );

      const { result, data } = response.data;


      if (result === 1 && data) {
        const heightInCm = data.height || 0;
        const feet = Math.floor(heightInCm / 30.48);
        const inches = Math.round((heightInCm - feet * 30.48) / 2.54);
const formatted = {
          name: data.name || '',
          age: data.age || '',
          genderID: data.genderID?.toString() || '',
          mstatusID: data.mstatusID?.toString() || '',
          heightFt: feet.toString(),
          heightIn: inches.toString(),
          occupationID: data.occupationID?.toString() || '',
          occupation: data.occupation || '',
          about: data.about || '',
        }
       setFormData(formatted);
       setInitialFormData(formatted);

      } else {
        console.warn('No details found or invalid token');
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  fetchDetails();
}, [token]);


const isFormChanged = () => {
  if (!initialFormData) return false;
  return JSON.stringify(formData) !== JSON.stringify(initialFormData);
};


  // Converts feet and inches to centimeters
  const convertHeightToCm = () => {
    const ft = parseFloat(formData.heightFt) || 0;
    const inch = parseFloat(formData.heightIn) || 0;
    return Math.round(ft * 30.48 + inch * 2.54);
  };

  const handleChange = (e) => {

     setIsSubmitted(false); // <-- reset submission status

    const { name, value } = e.target;

  let cleanedValue;
  if (name === 'about') {
    // For textarea: allow only letters, numbers, spaces, commas, and full stops
    cleanedValue = value.replace(/[^a-zA-Z0-9.,\s]/g, '');
   
  } else {
    // For other fields: allow only letters, numbers, and spaces (no punctuation)
    cleanedValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
  }


      setAnimateArrow(true)

        setFormData((prev) => ({
        ...prev,
        [name]: cleanedValue
      }));

     
  };

  // Handles react-select changes and sets IDs and clears manual input
  const handleSelectChange = (selected, idField, textField) => {

    setIsSubmitted(false); // <-- reset submission status

    if (selected?.value === '0') {
      setFormData((prev) => ({ ...prev, [idField]: '0', [textField]: '' }));
    } else {
      setFormData((prev) => ({ ...prev, [idField]: selected ? selected.value : '', [textField]: '' }));
    }
  };

  const makeOptions = (list) => [
    ...list.map((item) => ({ value: item.id.toString(), label: item.name })),
    { value: '0', label: 'Other' },
  ];

    const makeOptionswithOO = (list) => [
    ...list.map((item) => ({ value: item.id.toString(), label: item.name })),
  ];

  const validateForm = () => {
    const errs = [];

    if (!formData.name.trim()) errs.push('Name is required.');
    if (
  formData.age === undefined ||
  formData.age === null ||
  formData.age === '' ||
  isNaN(formData.age)
) {
  errs.push('Age is required.');
} else if (formData.age < 18 || formData.age > 99) {
  errs.push('Age must be between 18 and 99.');
}
    if (!formData.genderID) errs.push('Gender is required.');
    if (!formData.mstatusID) errs.push('Marital status is required.');



    if (!formData.heightFt.trim() || isNaN(formData.heightFt) || Number(formData.heightFt) < 0)
      errs.push('Valid height (feet) is required.');

    if (formData.heightIn && (isNaN(formData.heightIn) || Number(formData.heightIn) < 0))
      errs.push('Height (inches) must be a valid number.');

    // Validate height in cm (based on ft/in)
        const heightCm = convertHeightToCm();
        if (!heightCm || isNaN(heightCm)) {
        errs.push('Height must be a valid numeric value.');
        } else if (heightCm < 1 || heightCm > 300) {
         errs.push('Height must be between 1 ft and 9 ft 10 in.');
        }

 
    if (!formData.occupationID) errs.push('Occupation is required.');
    if (formData.occupationID === '0' && !formData.occupation.trim()) errs.push('Please enter occupation.');




    
     if (!formData.about) errs.push('About is required.');
    
         if(containsForbiddenContactInfo(formData.about))
         {
          errs.push('⚠️ Please don’t share phone numbers, emails, or social media IDs. Doing so may lead to your account being blocked.')
         }


    setTimeout(() => setAnimateArrow(false), 1000);
    return errs;
  };


  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMessage('');
    setLoading(true);

    const validationErrors = validateForm();
    if (validationErrors.length) {
      setErrors(validationErrors);
      setLoading(false);
       setTimeout(() => setAnimateArrow(false), 1000);
      return;
    }

    const payload = {
      ...formData,
      height: convertHeightToCm(),
    };


    try {
        const res = await axios.post(API_ENDPOINTS.DETAILS, payload, {
          headers: {
            token: tokenVal,
          },
        });
  

        const { result, user, opt, errors: serverErrors } = res.data;
    
        if (result === 1) {
           setIsSubmitted(true); 
          setMessage('Your details have been successfully updated.');
  setIsSubmitted(true);
  // Optionally: scroll to top
  window.scrollTo({ top: 0, behavior: 'smooth' });

        } else {
          const allMessages = [];
    
          if (Array.isArray(serverErrors)) {
            allMessages.push(...serverErrors);
          }
          if (user !== undefined) {
            allMessages.push(getStatusMessage(user));
          }
          if (opt !== undefined) {
            allMessages.push(getStatusMessage(opt));
          }
    
          setErrors(allMessages.length ? allMessages : ['Submission failed.']);
        }
      } catch (err) {


        const status = err.response?.status;
        const data = err.response?.data;
    
        if (status === 400 && Array.isArray(data?.errors)) {
          setErrors(data.errors);
        } else if (status === 400 && (data?.user || data?.opt)) {
          const failMessages = [];
          if (data.opt !== undefined) failMessages.push(getStatusMessage(data.opt));
          setErrors(failMessages);
        } else {
          setErrors(['Server error. Please try again later.']);
        }
      } finally {
         setTimeout(() => setAnimateArrow(false), 1000);
        setLoading(false); // Optional: hide loader
      }
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)',
        paddingTop: '4rem',
        
      }}
    >
      <div style={{ maxWidth: 480, padding:'10px',  width: '100%', margin: '0 auto' }}>
      


        <div className="text-center mb-4">     
          <span className="badge bg-secondary">Step 3 of 4</span>
          <h5 className="mt-2 wedding-heading">Enter Personal details</h5>
        </div>


        <form onSubmit={handleSubmit}>

          {message && (
            
            <div>
   
    <div className="text-success fw-semibold">

            <div className="alert alert-success mt-3" style={{ whiteSpace: 'pre-line' }}>
              <i className="bi bi-check-circle-fill small text-success me-2 fs-5"></i> {message}
            </div>

             </div>
  </div>
          )}

          {errors.length > 0 && (
            <div className="alert small alert-danger mt-3" style={{ backgroundColor: '#ffe0e0', color: '#cc0000' }}>
              <ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
            </div>
          )}


          <div className="mb-3">
            <label className="form-label text-muted">Full Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              autoComplete="name"
              maxLength={600}
              disabled
            />
            <small className="form-text text-muted mt-1">
           <i className="bi bi-exclamation-circle-fill text-warning me-1"></i>
           Full Name cannot be changed once entered.
            </small>

          </div>

        <div className="mb-3">
        <label className="form-label text-muted">Your Age</label>
        <input
          type="number"
          name="age"
          className="form-control"
          placeholder="Enter your age"
          value={formData.age || ''}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, age: e.target.value }))
          }
          min={18}
          max={99}
          disabled
        />
                              <small className="form-text text-muted mt-1">
  <i className="bi bi-exclamation-circle-fill text-warning me-1"></i>
  Age cannot be changed once entered.
</small>
      </div>

          <div className="mb-3">
            <label className="form-label text-muted">Gender</label>
            <select
              name="genderID"
              className="form-select"
              value={formData.genderID}
              onChange={handleChange}
              disabled
            >
              <option value="">Select Gender</option>
              <option value="0">Male</option>
              <option value="1">Female</option>
            </select>
                       <small className="form-text text-muted mt-1">
  <i className="bi bi-exclamation-circle-fill text-warning me-1"></i>
  Gender cannot be changed once entered.
</small>
          </div>

          <div className="mb-3">
            <label className="form-label text-muted">Marital Status</label>
            <select
              name="mstatusID"
              className="form-select"
              value={formData.mstatusID}
              onChange={handleChange} disabled
            >
              <option value="">Select Marital Status</option>
              <option value="0">Unmarried</option>
              <option value="1">Divorced</option>
              <option value="2">Widow</option>
              <option value="3">Married</option>
            </select>
             <small className="form-text text-muted mt-1">
             <i className="bi bi-exclamation-circle-fill text-warning me-1"></i>
            Marital Status cannot be changed once entered.
            </small>
          </div>

<div className="mb-3">
      
          <div className="d-flex gap-2">
            <div style={{ flex: 1 }}>
              <label className="form-label text-muted">Height (Feet)</label>
              <input
                type="number"
                name="heightFt"
                className="form-control"
                placeholder="Feet"
                value={formData.heightFt}
                onChange={handleChange}
                min={0}
                maxLength={1} disabled
              />
            </div>
            <div style={{ flex: 1 }}>
              <label className="form-label text-muted">Height (Inches)</label>
              <input
                type="number"
                name="heightIn"
                className="form-control"
                placeholder="Inches"
                value={formData.heightIn}
                onChange={handleChange}
                min={0}
                maxLength={2} disabled
              />
            </div>
          </div>
 <small className="form-text text-muted mt-1">
             <i className="bi bi-exclamation-circle-fill text-warning me-1"></i>
            Height cannot be changed once entered.
            </small>
    </div>
          

          {/* Occupation */}
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-1">
            <label className="form-label text-muted">Occupation</label>
             <small className="text-muted d-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
              <i className="bi bi-question-circle-fill text-secondary"></i>
              If not found, select <strong>"Other"</strong>
            </small>
            </div>
            <Select
              options={makeOptions(occupationList)}
              onChange={(selected) => handleSelectChange(selected, 'occupationID', 'occupation')}
              value={makeOptions(occupationList).find((o) => o.value === formData.occupationID)}
              classNamePrefix="react-select"
              placeholder="Select Occupation"
            />
            {formData.occupationID === '0' && (
              <input
                type="text"
                name="occupation"
                className="form-control mt-2"
                placeholder="Enter Occupation"
                value={formData.occupation}
                onChange={handleChange}
              />
            )}
          </div>



          {/* About You */}
          <div className="mb-3">
            <label className="form-label text-muted">About You</label>
            <textarea
              name="about"
              className="form-control"
              rows={4}
              maxLength={600}
              placeholder="Tell us about yourself..."
              value={formData.about}
              onChange={handleChange}
            />
             <div className="text-end text-muted small">
                    {formData.about.length} / 600
            </div>

              <div
  className="mb-2 text-danger small d-flex align-items-start gap-2"
  style={{
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeeba',
    padding: '10px',
    borderRadius: '8px',
    fontSize: '0.85rem',
    lineHeight: '1.4',
  }}
>
  <i className="bi bi-exclamation-triangle-fill mt-1" style={{ color: '#d39e00' }}></i>
  <div>
    <strong>Warning:</strong> Do not share phone numbers, email, or any contact/social handles (e.g. WhatsApp, Instagram, Facebook, Telegram, Snapchat, Twitter, LinkedIn, etc.).
    Violating this rule may result in your account being <strong>blocked.</strong>
    <strong>AI Engine will automatically allow contact sharing once a meaningful and respectful conversation has been established.</strong>
  </div>
</div>

          </div>


<button
  type="submit"
  className="btn w-100 mt-3 d-flex justify-content-center align-items-center gap-2 px-3 py-2"
  style={{ backgroundColor: '#ff69b4', color: 'white' }}
  disabled={loading || isSubmitted || !isFormChanged()}
>
  {loading ? (
    <>
      <span>Saving...</span>
      <div className="spinner-border spinner-border-sm text-light ms-1" role="status" />
    </>
  ) : isSubmitted ? (
    <>
      <i className="bi bi-check-circle-fill fs-5"></i>
      <span>Saved</span>
    </>
  ) : (
    <>
      <span>Save</span>
      <i className={`bi bi-arrow-right-circle-fill ${animateArrow ? 'move-arrow' : ''} fs-5`} />
    </>
  )}
</button>


       {message && (
            <div className="alert alert-success mt-3" style={{ whiteSpace: 'pre-line' }}>
              {message}
            </div>
          )}

          {errors.length > 0 && (
            <div className="alert alert-danger mt-3" style={{ backgroundColor: '#ffe0e0', color: '#cc0000' }}>
              <ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
            </div>
          )}



        </form>




      </div>
    </div>
  );
}

export default UpdateDetailsForm;
